export const environment = {
  production: true,
  pollApi: "https://hunch.in/graphql",
  pollInternalApi: "http://graphql-server-service.graphql-server.svc.cluster.local:80/graphql",
  // pollInternalApi: "http://localhost:4001/graphql",

  pollWeb: "https://hunch.in/",

  ADJUST_EMBED_TRACKER: "10klsqhm",
  ADJUST_TRACKER_URL: "https://app.adjust.net.in",
  HUNCH_DEEPLINK_HOST: "hunch://hunch.in",
  ADJUST_WEBSITE_TRACKER: "rsgvyu3",
  ADJUST_TWITTER_BOT_TRACKER: "11oynwyj",
  ADJUST_DYNAMIC_URL: "https://hunch.go.link",

  SHARE_URL: "https://share.hunch.in",
  assetDomain: "https://assets.hunch.in/",
  bucketUrl: "cf-simple-s3origin-assets-hunch-in",
  s3CompressEndPointUrl: "https://resources.hunch.in/",
  mixPanelKey: '065219ac120106a504a13f4f37d5d54e',
  gaKey: 'AW-10841969382',
  mostVibedData: [
    { title: 'Who slayed the MET Gala theme this year?', voteCount: 0, createdBy: 'Hunch', pollId: 'who-slayed-the-met-gala-theme-this-year-2ztib' },
    { title: 'What’s the most painful thing you went through with #Puberty? ', voteCount: 0, createdBy: 'Hunch', pollId: 'what-s-the-most-painful-thing-you-went-through-with-puberty-B9xQO' },
    { title: 'Did you face anger issues in your #Puberty? ', voteCount: 0, createdBy: 'Hunch', pollId: 'did-you-face-anger-issues-in-your-puberty-ikeMu' },
    { title: 'Is #Feminism and women empowerment the same thing? ', voteCount: 0, createdBy: 'Hunch', pollId: 'is-feminism-and-women-empowerment-the-same-thing-avAH2' },
    { title: 'Family caught you in action?', voteCount: 0, createdBy: 'Hunch', pollId: 'family-caught-you-in-action' },
    // Add more poll objects as needed
  ],
  categoryOrder: [
    "Dating and Relationships",
    "Books and Comics",
    "Lifestyle",
    "Music",
    "Food and Drinks",
    "Philosophy and Religion",
    "Technology and Internet",
    "Nature",
    "Would You Rather",
    "Gaming",
    "College Musings",
    "Fashion and Makeup",
    "Pets and Animals",
    "Health and Wellness",
    "Language and Names",
    "Random",
    "Anime",
    "Sports",
    "Travel and Geography",
    "Law and Order",
    "Friends and Family",
    "Holidays",
    "Art Culture and History",
    "Finance",
    "Celebrities",
    "City Musings",
    "Politics",
    "Shopping",
  ],
  popularSearches: [
    "Inside Out 2",
    "Billie Eilish",
    "Sabrina Carpenter",
    "Smile 2",
    "Justin Timberlake",

  ]

};
